<template>
<!--   <form action="#" method="POST" data-vv-scope="signup_agent_form" autocomplete="off" ref="form" id="form" @change="$emit('checkFormOnChange')" @input="$emit('checkFormOnChange')" @select="$emit('checkFormOnChange')" @click="$emit('checkFormOnChange')" @blur="$emit('checkFormOnChange')" @focus="$emit('checkFormOnChange')" @focusout="$emit('checkFormOnChange')" @keyup="$emit('checkFormOnChange')" @invalid="$emit('checkFormOnChange')" @touchstart="$emit('checkFormOnChange')" @touchend="$emit('checkFormOnChange')" @touchcancel="$emit('checkFormOnChange')" @scroll="$emit('checkFormOnChange')" @mouseover="$emit('checkFormOnChange')" @mouseleave="$emit('checkFormOnChange')" @mouseenter="$emit('checkFormOnChange')">-->
   <form action="/sc/client/create" method="POST" data-vv-scope="signup_agent_form" autocomplete="off" ref="form" id="form" enctype="multipart/form-data">
        <form-one></form-one>
        <form-two v-if="formStep > 0"></form-two>
        <form-three v-if="formStep > 1"></form-three>
        <form-four v-if="formStep > 2"></form-four>
    </form>
</template>


<script>
    import formOne from "./formOne.vue";
    import formTwo from "./formTwo.vue";
    import formThree from "./formThree.vue";
    import formFour from "./formFour.vue";
    export default{
        inherit: true,
        inject: ['$validator'],
        name: "forms",
        components:{
            "form-one": formOne,
            "form-two": formTwo,
            "form-three": formThree,
            "form-four": formFour
        },
        data: () => ({
            check_data: 0
        }),
        props:{
            formStep: Number
        },
        methods:{}
    }
</script>

<!-- style forms element below -->
<style lang="scss">
    $themeColor: #098BAE;
    $themeColorOpt50: rgba(9,139,174,0.5);
    $formColor: #203540;
    $validColor: #33DB40;
    $invalidColor: #FF1A1A;
    $expendElBgColor: #E5F3F7;
    $expendElActiveColor: #2993CC;
    $overlay: rgba(0,0,0,0.9);
    $leaveAlertBtn: rgba(32, 53, 64, 0.5);
    .overlay{
        position: fixed;
        width: 100%;
        height: 100%;
        background: $overlay;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        > .container{
            @media screen and (max-width: 640px){
                width: 100%;
            }
            width: 90%;
            max-width: 1240px;
            max-height: 100%;
            overflow: auto;
            background: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .back-btn{
                position: absolute;
                height: 35px;
                width: 35px;
                cursor: pointer;
                margin: 5px;
                padding: 7.5px;
                z-index: 10;
                background: white;
                border-radius: 50%;
            }
            .back-btn-svg{
                fill: $themeColor;
            }
            > .content{
                line-height: 1.45;
                > div{
                    padding: 15px;
                }
                img{
                    max-width: 400px;
                    width: 100%;
                }
                iframe, object{
                    height: 100vh;
                    width: 100%;
                }
                .download-btn{
                    position: fixed;
                    z-index: 999;
                    bottom: 0;
                    padding: 5px;
                    background: white;
                    width: 100%;
                    a{
                        text-decoration: none;
                        color: $themeColor;
                    }
                }
            }
            > .btn-container{
                cursor: pointer;
/*                color: $themeColor;*/
                font-weight: bold;
                display: flex;
                justify-content: center;
                align-content: center;
                padding: 15px;
                > a.btn{
                    text-decoration: none;
                    &:first-of-type{
                        color: $leaveAlertBtn;
                    }
                }
                > .btn{
                    max-width: 100px;
                    flex: 1;
                    cursor: pointer;
                    flex-direction: row;
                    &:first-of-type{
                        color: $leaveAlertBtn;
                    }
                    &:last-of-type{
                        color: $themeColor;
                    }
                }
            }
        }
    }
    fieldset{
        margin-top: 60px;
        border: none;
        box-sizing: border-box;
        width: 100%;
        padding: 0;
    }
    fieldset:last-child{
        margin-bottom: 60px;
    }
    legend{
        text-align: left;
        width: 200px;
        padding-bottom: 5px;
        border-bottom: 1px solid $themeColor;
        position: relative;
        color: $themeColor;
    }
    legend:after{
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        background: $themeColor;
        bottom: -5px;
        right: 0;
        transform: rotate(45deg);
    }
    input, .half-line > span:first-child, .one-line > span:first-child{
        border: none;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        box-sizing: border-box;
/*        padding: 10px;*/
        padding: 17.5px 0 7px 0;
        font-size: 16px;
        color: $formColor;
        height: 100%;
        display: block;
        text-align: left;
    }
    .half-line > span:first-child, .one-line > span:first-child{
        position: relative;
        width: auto;
        display: inline-block;
        text-align: left;
        flex: initial;
        white-space: nowrap;
    }
    .one-line.slider{
        display: block;
        padding-bottom: 20px;
    }
    .one-line.slider > span:first-child{
        display: block;
        width: 100%;
    }
    .half-line > label, .one-line > label{
        display: inline-block;
        flex: 1;
        text-align: center;
        padding: 17.5px 0 7px 0;
        white-space: nowrap;
        position: relative;
        cursor: pointer;
        transition: 0.5s;
    }
    .half-line > input[type="radio"]:checked+label, .one-line > input[type="radio"]:checked+label{
        color: $validColor;
    }
    .half-line > input[type="checkbox"]+label, .one-line > input[type="checkbox"]+label{
        width: 60px;
        height: 30px;
        user-select: none;
        flex: none;
        padding: 0;
        align-self: flex-end;
        margin-bottom: 5px;
        margin-left: 5px;
    }
    input[type="checkbox"]+label:before, input[type="checkbox"]+label:after{
        content: "";
        display: block;
        position: absolute;
        cursor: pointer;
    }
    input[type="checkbox"]+label:before{
        width: 100%;
        height: 100%;
        background-color: #CCCCCC;
        border-radius: 9999em;
        transition: background-color 0.25s ease;
    }
    input[type="checkbox"]+label:after{
        top: 1px;
        left: 1px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.16);
        border: 0.5px solid #999999;
        transition: 0.25s ease;
        content: "✕";
        line-height: 28px;
        text-align: center;
        box-sizing: border-box;
        color: #999999;
        font-weight: lighter;
    }
    .half-line > input[type="checkbox"]:checked+label:before, .one-line > input[type="checkbox"]:checked+label:before{
        background-color: $validColor;
    }
    .half-line > input[type="checkbox"]:checked+label:after, .one-line > input[type="checkbox"]:checked+label:after{
        left: 31px;
        content: "✓";
        color: $validColor;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.16);
    }
    .label-after-break:after{
        content: "";
        border-right: 1px solid $formColor;
        position: absolute;
        right: 0;
        bottom: 0;
        height: 20px;
    }
    .label-before-break:before{
        content: "";
        border-left: 1px solid $formColor;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 20px;
    }
    .label-before-break.upload:before{
        content: "";
        border-left: 1px solid $formColor;
        position: absolute;
        left: 5px;
        bottom: -10px;
        height: 20px;
    }
    input[type="radio"], input[type="file"], input[type="checkbox"]{
        display: none;
    }
    input:focus{
        outline: none;
    }
    input::placeholder{
        color: $formColor;
    }
    .half-line, .one-line{
        position: relative;
        height: 50px;
        margin-top: 10px;
        vertical-align: top;
        text-align: left;
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
    }
    .one-line{
        height: auto;
        min-height: 49px;
    }
    .half-line > span:last-child, .one-line > span:last-child{
        position: absolute;
        font-size: 12px;
        left: 0;
        top: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100%;
    }
    .half-line > span.valid:last-child, .one-line > span.valid:last-child{
        color: $validColor;
    }
    .half-line > span.invalid:last-child, .one-line > span.invalid:last-child{
        color: $invalidColor
    }
    .half-line.right > span{
        left: 10px;
    }
    .half-line.right > span:first-child{
        left: 0;
    }
    .one-line{
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid $formColor;
    }
    .half-line{
/*        display: inline-block;*/
        width: 50%;
        box-sizing: border-box;
    }
    .half-line input{
        width: 100%;
    }
    .one-line input{
        width: 100%;
    }
    .half-line.left{
        border-bottom: 1px solid $formColor;
    }
    .half-line.right{
        border-bottom: 1px solid $formColor;
        border-left: 1px solid $formColor;
        padding-left: 10px;
    }
    .input-list-triggle{
        white-space: nowrap;
        box-sizing: border-box;
        padding: 17.5px 0 7px 0;
        height: 100%;
        outline: none;
        position: relative;
    }
    .add-to-list-triggle, .remove-from-list-triggle{
        user-select: none;
        cursor: pointer;
        display: inline-block;
    }
    .remove-from-list-triggle{
        padding: 0 5px;
    }
    .add-drop-list-container{
        display: inline-flex !important;
        flex-wrap: nowrap !important;
        flex-direction: row !important;
    }
    .add-drop-list-container > span:first-child{
        position: relative;
        padding-right: 5px;
        white-space: nowrap;
        align-self: flex-end;
    }
    .add-drop-list-container > span:nth-child(2){
        position: relative;
        padding: 0 10px;
        font-size: 12px;
        line-height: 24px;
    }
    .add-drop-list-container > span:last-child{
        position: relative;
        padding-left: 5px;
        white-space: nowrap;
        align-self: flex-end;
    }
    .add-drop-list-container > span:nth-child(2):before{
        content: "";
        border-right: 1px solid $formColor;
        position: absolute;
        left: 0;
        bottom: -7.5px;
        height: 20px;
        margin-right: 5px;
    }
    .add-drop-list-container > span:nth-child(2):after{
        content: "";
        border-right: 1px solid $formColor;
        position: absolute;
        right: 0;
        bottom: -7.5px;
        height: 20px;
        margin-left: 5px;
    }
    .add-to-list-triggle:before{
        content: "+";
        width: 20px;
        height: 20px;
        background: $themeColorOpt50;
        line-height: 20px;
        text-align: center;
        display: inline-block;
        border-radius: 20px;
        margin-right: 5px;
    }
    .remove-from-list-triggle:before{
        content: "-";
        width: 15px;
        height: 15px;
        background: $themeColorOpt50;
        line-height: 15px;
        text-align: center;
        display: inline-block;
        border-radius: 15px;
        margin-right: 5px;
    }
    .dropdown-list-container{
        position: absolute;
        width: 100%;
        max-height: 200px;
        overflow: auto;
        left: 0;
        top: calc(100% + 5px);
        background: $expendElBgColor;
        z-index: 10;
        visibility: hidden;
        transition: visibility 0.1s;
    }
    .input-list-triggle:focus ~ .dropdown-list-container{
        visibility: visible;
    }
    .dropdown-list{
        height: 33px;
        box-sizing: border-box;
        padding: 10px;
        cursor: pointer;
    }
    .dropdown-list > span{
        border-bottom: 1px solid $formColor;
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .dropdown-list:last-child{
        margin-bottom: 10px;
    }
    .dropdown-list:last-child > span{
        border-bottom: none;
    }
    .info-btn{
        height: 20px;
        width: 20px;
        background: $themeColorOpt50;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        border-radius: 20px;
        margin: 0 5px;
        user-select: none;
    }
    .upload{
        width: 150px;
        background-image: url(../assets/upload-btn.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        flex: none !important;
        height: 35px;
        align-self: flex-end;
        margin-bottom: 10px;
    }
    .radio-select-slider-container.range{
        display: inline-block;
        position: relative;
        height: 10px;
        width: 100%;
        border: 0.5px solid $formColor;
        border-radius: 5px;
        z-index: 0;
        label{
            position: relative;
            z-index: 1;
            display: inline-block;
            cursor: pointer;
            height: 55px;
            transform: translateY(-10px);
        }
        .scale-container, .switcher{
            position: absolute;
        }
        .scale-container{
            display: flex;
            flex-direction: row;
            width: 100%;
            font-size: 12px;
            position: relative;
            margin-top: -30px;
            > span{
                flex: 1;
                user-select: none;
                &:before{
                    content: "";
                    position: absolute;
                    height: 10px;
                    width: 1px;
                    background: black;
                    top: -10px;
                    left: 50%;
                }
                > span{
                    white-space: nowrap;
                    position: absolute;
                }
            }
        }
        .switcher{
            top: -5px;
            height: 20px;
            background-color: $themeColor;
            border-radius: 5px;
            box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.16);
            color: white;
            text-align: center;
            opacity: 0;
            user-select: none;
        }
    }
    .radio-select-slider-container.progressive{
        display: inline-block;
        position: relative;
        height: 10px;
        width: 100%;
        border: 0.5px solid $formColor;
        border-radius: 5px;
        margin-bottom: 20px;
        z-index: 0;
        .radio-select-slider{
            position: absolute;
/*            float: left;*/
            display: block;
            height: 10px;
            width: 100%;
        }
        label{
            position: absolute;
            z-index: 1;
            display: inline-block;
            cursor: pointer;
            height: 55px;
/*            transform: translateY(-10px);*/
            display: block;
            text-align: center;
            font-size: 12px;
            > span{
                margin-top: 30px;
                display: inline-block;
                &:before{
                    content: "";
                    position: absolute;
                    height: 10px;
                    width: 1px;
                    background: black;
                    bottom: 25px;
                    left: 50%;
                }
            }
        }
        input[type="radio"]:checked ~ label{
/*            z-index: ;*/
            &:before{
                content: "";
                display: block;
                height: 9px;
                box-sizing: border-box;
                margin-top: 0.5px;
                background: $themeColor;
                position: absolute;
                left: 0;
                z-index: -1;
                border-radius: 5px;
            }
            &:after{
                content: "";
                display: block;
                height: 20px;
                width: 20px;
                position: absolute;
                box-shadow: 2px 2px 2px rgba(0,0,0,0.16);
                top: -5px;
                background: $themeColor;
                border-radius: 10px;
                transform: translateX(-10px);
            }
        }
    }
    .remind{
        text-align: left;
        font-size: 12px;
        padding: 15px 0;
    }
    .agreement-btn{
        cursor: pointer;
        color: $themeColor;
        font-weight: bold;
    }
    @media screen and (max-width: 640px){
        .half-line{
            width: 100%;
        }
        .half-line.right{
            border-bottom: 1px solid $formColor;
            border-left: none;
            padding-left: 0;
        }
        .half-line.right > span:last-child{
            left: 0;
        }
        .half-line > input[type="checkbox"] + label, .one-line > input[type="checkbox"] + label {
            align-self: center;
            margin-bottom: 0;
            margin-top: 10px;
            margin-left: 5px;
        }
        .one-line.upload-row{
            flex-direction: column;
        }
        .upload{
            width: 100%;
            margin-top: 10px;
        }
        .label-before-break.upload:before{
            content: none;
        }
        .add-drop-list-container{
            display: inline-block !important;
        }
        .add-drop-list-container > span:first-child{
            padding-right: 0;
            display: block;
        }
        .add-drop-list-container > span:nth-child(2){
            padding: 5px 0;
            padding-right: 5px;
            display: block;
            min-height: 24px;
            min-width: 24px;
        }
        .add-drop-list-container > span:last-child{
            padding-left: 0;
            display: block;
        }
        .add-drop-list-container > span:nth-child(2):before, .add-drop-list-container > span:nth-child(2):after{
            content: none;
        }
    }

    /* vuejs-datepicker style replace */
    .vdp-datepicker{
        width: 100%;
    }
    .vdp-datepicker > div:first-child{
        height: 100%;
        box-sizing: content-box;
    }
    .vdp-datepicker__calendar{
        width: 100% !important;
        background: $expendElBgColor !important;
        border: none !important;
        margin-top: 5px;
    }
    .vdp-datepicker__calendar .cell.selected {
        background: $expendElActiveColor;
    }
    .vdp-datepicker__calendar .cell.selected:hover {
        background: $themeColor;
    }
    .vdp-datepicker__calendar header span:hover {
        background: $themeColor !important;
    }
    .vdp-datepicker__calendar .cell:hover{
/*        border: 1px solid $themeColor;*/
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
      border: 1px solid $themeColor;
    }

    /* v-transition */
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>
